module.exports = __webpack_public_path__ + "static/media/fruits.9787d5ba.png";